// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__s27vw","label":"styles_label__kSM7U","editor":"styles_editor__bmpzc","btn":"styles_btn__VRlzh"};